import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useMarkAllNotificationsRead = (
  onSuccess?: (data: any) => void,
  onError?: (error: any) => void
) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async () => {
      const baseUrl = t("calling-pipeline-notifications");
      const response = await axios.post(`${baseUrl}/mark-all-read`);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      if (onError) onError(error);
    }
  });
};


